import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { Shell } from './components/Shell';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { DepositsPage } from './pages/Deposits';
import { DepositDetailPage } from './pages/DepositDetail';
import { DisbursementsPage } from './pages/Disbursements';
import { DisbursementDetailPage } from './pages/DisbursementDetail';
import { MerchantsPage } from './pages/Merchants';
import { MerchantDetailPage } from './pages/MerchantDetail';
import { MerchantCreatePage } from './pages/MerchantCreate';
import { WalletPage } from './pages/Wallet';
import { ApiCredentialsPage } from './pages/ApiCredentials';
import { NotFoundPage } from './pages/NotFound';
import { RolesPage } from './pages/Roles';
import { UsersPage } from './pages/Users';
import { AcceptInvitePage } from './pages/AcceptInvite';
import { ApiDocsPage } from './pages/ApiDocs';
import { AcquirersPage } from './pages/Acquirers';
import { SettingsPage } from './pages/Settings';
import { SecurityPage } from './pages/Security';
import { AuditLogPage } from './pages/AuditLog';
import { TransactionReportsPage } from './pages/TransactionReports';
import { TransactionSummaryPage } from './pages/TransactionSummary';
import { SettlementReportsPage } from './pages/SettlementReports';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />

      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="deposits" element={<DepositsPage />} />
        <Route path="deposits/:trxId" element={<DepositDetailPage />} />
        <Route path="disbursements" element={<DisbursementsPage />} />
        <Route path="disbursements/:trxId" element={<DisbursementDetailPage />} />
        <Route path="merchants" element={<MerchantsPage />} />
        <Route path="merchants/new" element={<MerchantCreatePage />} />
        <Route path="merchants/:id" element={<MerchantDetailPage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="api-credentials" element={<ApiCredentialsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="internal-users" element={<UsersPage />} />
        <Route path="roles" element={<RolesPage />} />
        <Route path="api-docs" element={<ApiDocsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="acquirers" element={<AcquirersPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="audit-log" element={<AuditLogPage />} />
        <Route path="reports/transactions" element={<TransactionReportsPage />} />
        <Route path="reports/summary" element={<TransactionSummaryPage />} />
        <Route path="reports/settlement" element={<SettlementReportsPage />} />
      </Route>

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
